import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../Shared/Navbar/Navbar";
import DataTable from "../../../Layout/Table/TableLayout";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import { baseURL } from "../../../Apiservices/Api";
import { FaEdit, FaTrash } from "react-icons/fa";


const AdminSupplier = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [suppliersData, setSuppliersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();


  const handleEdit = (id) => {
    navigate(`/admin-edit-supplier/${id}`);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this supplier?")) {
      try {
        const response = await fetch(`${baseURL}/api/deletesupplier/${id}`, {
          method: "DELETE",
        });
        if (!response.ok) {
          throw new Error("Failed to delete supplier");
        }
        // Refresh the list after deletion
        setSuppliersData((prev) => prev.filter((supplier) => supplier.id !== id));
      } catch (err) {
        alert("Error deleting supplier: " + err.message);
      }
    }
  };

  const columns = [
    { Header: "Supplier Name", accessor: "supplierName" },
    { Header: "Company Name", accessor: "companyName" },
    { Header: "Contact Person", accessor: "contactPerson" },
    { Header: "Phone", accessor: "phone" },
    { Header: "Email", accessor: "email" },
    { Header: "Address", accessor: "address" },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          <FaEdit
            style={{ color: "#ff9966", cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleEdit(row.original.id)}
          />
          <FaTrash
            style={{ cursor: "pointer", color: "ff9966" }}
            onClick={() => handleDelete(row.original.id)}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await fetch(`${baseURL}/api/supplierslist`);
        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
        const result = await response.json();
        setSuppliersData(Array.isArray(result.data) ? result.data : []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
  
    fetchSuppliers();
  }, []);
  

  return (
    <div className="salesViewLeadsContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`salesViewLeads ${collapsed ? "collapsed" : ""}`}>
        <div className="d-flex justify-content-between align-items-center">
          <h2>Suppliers</h2>
          <Button variant="primary" onClick={() => navigate("/admin-add-supplier")}>
            + Add Supplier
          </Button>
        </div>

        <div className="container mt-3">
          {loading ? (
            <div>Loading...</div>
          ) : error ? (
            <div className="text-danger">Error: {error}</div>
          ) : (
            <DataTable columns={columns} data={suppliersData} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminSupplier;
